import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=420d230d&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d230d",
  null
  
)

export default component.exports